var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_377_99535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 21.3333H4.57333L17.6 8.30667L15.6933 6.4L2.66667 19.44V21.3467V21.3333ZM0 24V18.3333L17.6 0.773333C17.8667 0.533333 18.16 0.333333 18.48 0.2C18.8 0.0666667 19.1467 0 19.4933 0C19.84 0 20.2 0.0666667 20.5333 0.2C20.8667 0.333333 21.16 0.533333 21.4 0.8L23.24 2.66667C23.5067 2.90667 23.7067 3.2 23.8267 3.53333C23.9467 3.86667 24.0133 4.2 24.0133 4.53333C24.0133 4.89333 23.9467 5.22667 23.8267 5.54667C23.7067 5.86667 23.5067 6.16 23.24 6.42667L5.66667 24H0ZM16.6267 7.37333L15.6933 6.4L17.6 8.30667L16.6267 7.37333Z",
    fill: "#706D6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_377_99535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon_pencil.3ccf5f94952e817cbfe07ff1b69a76ff.svg";
export { ForwardRef as ReactComponent };